import {
	IGasStationInfo,
	VehicleEngineType,
	VehicleFuelType,
	getVehicleFuelTypeName,
} from '~/shared';

import { IObservable, Subject } from '../../utils';
import { VehicleServiceStub } from '../VehicleService/VehicleServiceStub';
import { IVehicleService } from '../VehicleService/vehicleServiceTypes';
import { IGasStationService } from './gasStationServiceTypes';

export class GasStationServiceStub implements IGasStationService {
	private gasStationInfo = new Subject<IGasStationInfo>({
		engineType: VehicleEngineType.Petrol,
		fuelTypes: {
			[VehicleFuelType.Petrol92]: 42,
			[VehicleFuelType.Petrol95]: 44,
			[VehicleFuelType.Petrol98]: 46,
			[VehicleFuelType.Petrol100]: 52,
		},
		// engineType: VehicleEngineType.Electric,
		// fuelTypes: {
		// 	[VehicleFuelType.Electric220]: 42,
		// 	[VehicleFuelType.Electric380]: 44,
		// 	[VehicleFuelType.Electric500]: 46,
		// },
		id: 0,
	});

	constructor(private readonly vehicles?: IVehicleService) {}

	public getActiveGasStationInfo(): IObservable<IGasStationInfo> {
		return this.gasStationInfo;
	}

	public getFuelTypeName(fuelType: VehicleFuelType): string {
		return getVehicleFuelTypeName(fuelType);
	}

	public getTotalPrice(
		fuelType: VehicleFuelType,
		amount?: number | undefined,
	): number {
		if (amount === undefined) {
			return 7777;
		} else {
			return this.gasStationInfo.getValue().fuelTypes[fuelType]! * amount;
		}
	}

	public async buyFuel(
		fuelType: VehicleFuelType,
		amount?: number | undefined,
	): Promise<void> {
		console.log('buyFuel', { fuelType, amount });
	}

	public async drainFuel(amount?: number): Promise<void> {
		console.log('drainFuel', { amount });
		if (this.vehicles instanceof VehicleServiceStub) {
			this.vehicles.stubDrainLocalFuel(amount);
		}
	}

	public async closePanel(): Promise<void> {
		console.log('closePanel');
	}
}
